<template>
  <div>
    <template v-if="scoreAlert">
      <div class="profile-score-alert" v-if="scoreAlert.category_rate_high && scoreAlert.category_rate_high_list">
        <font-awesome-icon :icon="['fas', 'heart']" style="margin-right: 5px; color:#67c23a"/>
        {{ scoreAlert.category_rate_high_list.toString() }}の投稿が得意なインフルエンサーです。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.comments_count_high">
        <font-awesome-icon :icon="['fas', 'heart']" style="margin-right: 5px; color:#67c23a"/>
         コメントが平均を上回っています。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.average_engagement_rate_high">
        <font-awesome-icon :icon="['fas', 'heart']" style="margin-right: 5px; color:#67c23a"/>
         エンゲージメント率が平均を上回ってます。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.followers_growth_rate_high">
        <font-awesome-icon :icon="['fas', 'heart']" style="margin-right: 5px; color:#67c23a"/>
         フォロワーが増加傾向です。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.median_video_play_rate_90_high">
        <font-awesome-icon :icon="['fas', 'heart']" style="margin-right: 5px; color:#67c23a"/>
        リールの投稿が得意なインフルエンサーです。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.gifting_high">
        <font-awesome-icon :icon="['fas', 'heart']" style="margin-right: 5px; color:#67c23a"/>
         ギフティング成功率が高いインフルエンサーです。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.use_other_sns">
        <font-awesome-icon :icon="['fas', 'heart']" style="margin-right: 5px; color:#67c23a"/>
         複数のSNSで活躍しています。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.sexy">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        男性向けのコンテンツが多めです。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.female_audience">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        女性中心のフォロワーのため、男性向け商材のPRに不向きです。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.male_audience">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        男性中心のフォロワーのため、女性向け商材のPRに不向きです。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.pr_rate">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        PR投稿の頻度が高いため、PR効果が薄い可能性があります。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.egr">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        エンゲージメント率が0.5%を下回っています。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.egr_hide_likes">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        いいね非表示です。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.growth">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        フォロワーが減少傾向です。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.ff">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        相互フォローによりフォロワーを獲得している可能性があります。
      </div>
      <div class="profile-score-alert" v-if="scoreAlert.frequency">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 5px; color:#EC3232"/>
        投稿頻度が低く、アカウントパワーが低下する可能性があります。
      </div>
    </template>
    <template v-else-if="scoreAlert === false">
      <div class="profile-score-alert" style="margin-bottom: 0px">
        <font-awesome-icon :icon="['fas', 'check-circle']" style="margin-right: 5px; color:#0095f6"/>
        良好なアカウントです。
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    tabs: String,
    profile_data: Object
  },
  data(){
    return {
      scoreAlert: {}
    }
  },
  computed:{
    currentTabName() {
      return this.tabs;
    },
  },
  mounted() {
    this.load(this.currentTabName);
  },
  methods: {
    load(tabName){
      if( tabName === "analysis"){
        this.scoreAlert = this.profile_data.score_alert;
      }else{
        this.scoreAlert = this.getScoreAlertForSummary();
      }
    },
    getScoreAlertForSummary(){
      const tmpAlert = {};
      const order = [
        "category_rate_high", // 1,
        "comments_count_high", // 2,
        "average_engagement_rate_high", // 3,
        "followers_growth_rate_high", // 4,
        "median_video_play_rate_90_high", // 5,
        "use_other_sns", // 6,
        "gifting_high", // 6.5,
        "sexy", // 7,
        "female_audience", // 8,
        "male_audience", // 8,
        "pr_rate", // 9,
        "egr", // 10,
        "egr_hide_likes", // 10,
        "growth", // 11,
        "ff", // 12,
        "frequency", // 13,
      ];
      for( const key of order){
        //  summaryの表示上限5
        if( Object.keys(tmpAlert).length < 5 && this.profile_data.score_alert[key] ){
          tmpAlert[key] = true;
        }
      }
      // category表示がある場合はlistを追加
      if( tmpAlert["category_rate_high"] ){
        tmpAlert["category_rate_high_list"] = this.profile_data.score_alert["category_rate_high_list"];
      }
      return tmpAlert;
    }
  },
  watch: {
    currentTabName() {
      this.load(this.currentTabName);
    }
  }
}
</script>
